"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleRateLimitCounter = void 0;
class SimpleRateLimitCounter {
    constructor(counterMap = new Map()) {
        this.counterMap = counterMap;
    }
    getCount(key) {
        var _a;
        return (_a = this.counterMap.get(key)) !== null && _a !== void 0 ? _a : 0;
    }
    inc(key) {
        if (!this.counterMap.has(key)) {
            this.counterMap.set(key, 0);
        }
        this.counterMap.set(key, this.counterMap.get(key) + 1);
    }
    dec(key) {
        const currentCount = this.counterMap.get(key);
        if (currentCount === 1) {
            this.counterMap.delete(key);
        }
        else {
            this.counterMap.set(key, currentCount - 1);
        }
    }
}
exports.SimpleRateLimitCounter = SimpleRateLimitCounter;
